"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const money_1 = require("../../helper/money");
const offerColumns_1 = require("../../helper/offerColumns");
const path_1 = require("../../helper/path");
const TableSub_1 = __importDefault(require("../TableSub"));
const AssetsOfferTableExpandedItem = (props) => {
    const { data } = props;
    if (!data?.items) {
        return react_1.default.createElement("div", { className: "znd-assets-table-sub" });
    }
    return (react_1.default.createElement("div", { className: "znd-assets-table-sub" },
        react_1.default.createElement("div", { className: "d-flex flex-row" },
            react_1.default.createElement(TableSub_1.default, { columns: (0, offerColumns_1.getOffersDetailColumns)(), data: data.items, className: "znd-assets-table-sub__table" })),
        (data?.orderedAt ?? null) === null ? (react_1.default.createElement("div", { className: "d-flex flex-row align-items-end mt-3" },
            react_1.default.createElement("table", { className: "znd-offers-table__sub-table" },
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", { className: "znd-offers-table__sub-table__row" },
                        react_1.default.createElement("td", null, (0, translation_1.t)('myassets.offer.table.subtotal')),
                        react_1.default.createElement("td", null, data.price ? (0, money_1.moneyFormat)(data.price, data.currencyCode) : null)),
                    react_1.default.createElement("tr", { className: "znd-offers-table__sub-table__row" },
                        react_1.default.createElement("td", null, (0, translation_1.t)('myassets.offer.table.subtotal_excluding'))))))) : null,
        (data?.shopOrderId ?? null) !== null && (data?.orderedAt ?? null) !== null ? (react_1.default.createElement("div", { className: "d-flex flex-row align-items-end mt-3 mx-3" },
            react_1.default.createElement(react_router_dom_1.Link, { className: "ml-auto", to: (0, path_1.localePath)(Paths_1.PATH_USER_PROFILE_ORDERS_EXPANDED).replace(':orderId', data.shopOrderId ?? '') }, (0, translation_1.t)('myassets.offer.link_order_details')))) : null));
};
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(AssetsOfferTableExpandedItem));
